<template>
    <div>
        <transition name="fade" appear>
            <div v-if="!loading && !capRunning" class="page welcome-page">

                <section class="pb-6">
                    <v-container id="hero-container">
                        <div class="hero-background">
                            <v-img src="/img/hero.png" alt="hero image" />
                            <div class="hero-content">
                                <h1 class="hero-content__title">اهلا بيك</h1>
                                <h2 class="hero-content__subtitle">في منصة الدكتور في الفيزياء</h2>
                            </div>
                        </div>
                    </v-container>
                </section>

                <section v-if="featuredCourses && featuredCourses.length">
                    <v-container :class="{'px-0': phoneOnly}">
                        <div class="d-flex flex-column flex-md-row justify-space-between align-center mb-4 mb-lg-15">
                            <h2 class="strong-text--text font-weight-regular d-flex align-center">
                                <v-icon :size="pcOnly ? 45 : 36" color="strong-text" class="ml-2">mdi-play-box-multiple-outline</v-icon>
                                <span>الدورات التعليمية</span>
                            </h2>
                            <template v-if="pcOnly">
                                <div class="flex-grow-1 mx-12">
                                    <v-divider></v-divider>
                                </div>
                                <div>
                                    <v-btn outlined color="primary" :to="{name: 'courses'}">
                                        <span>الانتقال إلى الدورات</span>
                                        <v-icon right>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </div>
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="px-0">
                            <course-list-item v-for="(course, i) in featuredCourses" class="px-7 px-lg-4" :key="course.id + '-' + i" :course="course" />

                            <div class="my-4 mx-6">
                                <v-btn block outlined color="primary" :to="{name: 'courses'}">
                                    <span>الانتقال إلى الدورات</span>
                                    <v-icon right>mdi-arrow-left</v-icon>
                                </v-btn>
                            </div>
                        </v-list>
                    </v-container>
                </section>

                <section class="pb-6">
                    <v-container>
                        <div class="physics-promo">
                            <h2 class="physics-promo__title">للفيزياء اسرار</h2>
                            <h3 class="physics-promo__subtitle">هتاخدها في صوره افكار</h3>
                        </div>
                    </v-container>
                </section>

                <slot name="footer" />
            </div>
        </transition>


        <app-welcome-dialog v-if="platform == 'ios'" v-model="appWelcomeDialog" />
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import ESection from '@/components/default/layouts/e-section'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Welcome",
    data(){
        return {
            loading: false,
        }
    },
    components: {
        ESection,
        CourseCard,
        CourseListItem,
        AppWelcomeDialog
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        }
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    // this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            if (this.platform === 'ios'){
                this.appWelcomeDialog = true;
            }else{
                this.$router.push({name: 'login'});
            }
        }else{
            if (!this.featuredCourses || this.featuredCourses.length === 0){
                this.loadData();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#hero-container {
    @media (max-width: 960px) {
        padding: 0 !important;
        margin: 0 !important;
    }
}

.hero-background {
    $transition-duration: 80s;
    
    display: flex;
    position: relative;
    align-items: flex-start;
    border-radius: 12px;
    background-image: url('/img/hero-section-bg.png');
    background-size: 80%;
    background-repeat: repeat-x;
    animation: scrollPattern $transition-duration linear infinite;

    @media (min-width: 960px) {
        max-height: 85vh;
    }

    @media (max-width: 600px) {
        flex-direction: column-reverse;
        align-items: center;
        justify-content: flex-start;
        height: auto;
        animation-duration: 30s;
        .hero-content{
            margin-bottom: 0.75rem;
        }
    }
}

@keyframes scrollPattern {
    from { background-position: 0 0; }
    to { background-position: 100% 0; }
}

.hero-content {
    position: relative;
    top: 0;
    left: 0;
    margin-top: 2rem;
    text-align: center;
    
    @media (min-width: 600px) {
        position: absolute;
        top: 25%;
        left: 8%;
    }
    

    &__title {
        font-family: 'Bukra', sans-serif !important;
        font-weight: 800;
        font-size: clamp(2rem, calc(5vw + 1rem), 4.5rem);
        margin-bottom: clamp(1rem, 3vw, 3rem);
        color: var(--v-primary-base);

        text-shadow: 2px 3px 4px #fff;
    }
    
    &__subtitle {
        font-family: 'Bukra', sans-serif !important;
        font-size: clamp(1.25rem, calc(2.5vw + 0.5rem), 2.5rem);
        line-height: normal;
        text-shadow: 2px 3px 4px #fff;

    }
}

.physics-promo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;


    &__title {
        font-family: 'Bukra', sans-serif !important;
        font-size: clamp(2.25rem, calc(4vw + 1rem), 3.5rem);
        color: var(--v-primary-base);
        line-height: normal;
    }
    
    &__subtitle {
        font-family: 'Bukra', sans-serif !important;
        line-height: normal;
        font-size: clamp(1.5rem, calc(2vw + 0.75rem), 2.25rem);
        color: var(--v-strong-text-base);
    }
}
</style>